import { render, staticRenderFns } from "./DraftMessageTable.vue?vue&type=template&id=4898acca&scoped=true&lang=pug"
import script from "./DraftMessageTable.vue?vue&type=script&lang=ts"
export * from "./DraftMessageTable.vue?vue&type=script&lang=ts"
import style0 from "./DraftMessageTable.vue?vue&type=style&index=0&id=4898acca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4898acca",
  null
  
)

export default component.exports